import React, { useState } from "react";
import { useSelector } from "react-redux";
import { fetchGlossary } from "./../redux/ducks/glossary";
import useStatusThunk from "../hook/useStatusThunk";
import useEffectWithoutLoad from "../hook/useEffectWithoutLoad";
import useAuthEffect from "../hook/useAuthEffect";
import { mapData } from "../helpers/mapRow";
import { Table } from "../components/dumb/DataTable";
import { fetchTask } from "../redux/ducks/task";
import AddTerm from "../components/smart/buttonPopups/AddTerm";

const TaskGlossaryRoute = ({ match }) => {

    const taskID = match.params.taskID;
    const glossaryID = match.params.glossaryID;
    const task = useSelector(state => state.task.tasks[taskID]);
    const glossary = useSelector(state => state.glossary.glossaries[glossaryID]);
    const [dispatch_fetchTask, status_fetchTask, error_fetchTask] = useStatusThunk(fetchTask);
    const [dispatch_fetchGlossary, status_fetchGlossary, error_fetchGlossary] = useStatusThunk(fetchGlossary);
    const [rows, setRows] = useState([]);

    useAuthEffect(isAuth => {
        dispatch_fetchGlossary({ glossaryID });
        dispatch_fetchTask({ taskID });
    });

    useEffectWithoutLoad(() => {
        if (status_fetchTask == "success" && status_fetchGlossary == "success") {
            setRows(glossary.terms.map((term, index) => {
                const target = term.targets.find(target => target.lang == task.targetLang);
                return {
                    ID: term.id,
                    index,
                    source: term.source,
                    target: target?.text
                }
            }));
        }
    }, [status_fetchTask, status_fetchGlossary, task]);

    return (
        <div className="columns-container">
            <div className="column column--primary">
                <Terms taskID={taskID} rows={rows} glossaryID={glossaryID} sourceLang={task?.sourceLang} targetLang={task?.targetLang} />
            </div>
        </div >
    )
}

const Terms = props => {

    const renderRow = (row, renderData) => <React.Fragment>
        {renderData(row.ID, { key: "id" })}
        {renderData(row.source, { key: "source" })}
        {renderData(row.target, { key: "target" })}
        {renderData(row.note, { key: "note" })}
    </React.Fragment>

    const titleContent = <AddTerm glossaryID={props.glossaryID} taskID={props.taskID} />;

    return (
        <Table titleContent={titleContent} title="terms" renderRow={renderRow} rows={props.rows} cols={[
            { name: "id", sortCol: "ID" },
            { name: props.sourceLang, sortCol: "source" },
            { name: props.targetLang, sortCol: "target" },
            { name: "note", sortCol: "note" }
        ]} />
    )
}


export default TaskGlossaryRoute;